import { render, staticRenderFns } from "./DataFilter.vue?vue&type=template&id=a844cee6&scoped=true"
import script from "./DataFilter.vue?vue&type=script&lang=js"
export * from "./DataFilter.vue?vue&type=script&lang=js"
import style0 from "./DataFilter.vue?vue&type=style&index=0&id=a844cee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a844cee6",
  null
  
)

export default component.exports